import { PageContainer } from '@/components/page/PageContainer';
import { PageSizer, SizerMode } from '@/components/page/PageSizer';
import { Button } from '@/components/shared/button/Button';
import { TSCard } from '@/components/shared/card/Card';
import Lottie from 'lottie-react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import successAnimation from '../../components/shared/animations/successAnimation.json';

interface MyScheduleChangeRequestedProps {}

const ChangeRequestedCard: FC<MyScheduleChangeRequestedProps> = () => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <PageSizer mode={SizerMode.PAGE} className="justify-items-center">
        <TSCard className="flex flex-col items-center text-center p-10 w-[90%] sm:w-3/4 md:w-1/2 justify-center">
          <Lottie className="h-32" animationData={successAnimation} loop={false} />
          <div className="space-y-5">
            <div className="space-y-3">
              <h1 className="text-2xl font-bold">Request Sent</h1>
              <p className="text-xl text-muted-foreground mb-5">A manager will review your schedule change.</p>
            </div>
            <Button big primary className="w-full" onClick={() => navigate('/')}>
              Back to Home
            </Button>
          </div>
        </TSCard>
      </PageSizer>
    </PageContainer>
  );
};

export default ChangeRequestedCard;
